import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import Typography from 'material-ui/Typography';
import Button from 'material-ui/Button';

class Home extends Component {

	render() {

		const style = {
			margin: {
				margin:"25px",
				fontWeight: "lighter"
			},
			list: {
				textAlign: "left"
			}

		};

		return (
			<section>
				<div>
					<div className='container'>
						<Typography variant="headline" style={{ fontSize: "35px" }}>
							Welcome
						</Typography>
						<Typography style={style.margin} component="div">
						With this playful game method you will  discover  your  personal talents  related to the
						principles of the SDG’s (Sustainable Development Goals) and the Earth Charter <br /><br />



						This game method is based on the combination of elements of <br />
						Myers & Briggs, Jung's Type Indicator and the successful coaching format developed by Inner Sense.
<br /><br />


						Outcome:<br /><br />
						<Typography >
						1. You will  get insights in your personal sustainable profile which you can share with your friends / colleagues<br />
						2. You will get 1 sustainable personal development point  to focus on<br />
						3. You will receive your sustainable personal profile + personal development point per mail<br /><br />
						</Typography>

						This  game method will take you less than 15 minutes<br /><br />



						</Typography>

						<Link to={'/introduction'} >
							<Button variant="raised" style={style.margin} color="primary">
								Next
							</Button>
						</Link>
					</div>
				</div>
			</section>
		);
	}
}

export default Home;



// WEBPACK FOOTER //
// ./src/views/HomeView.jsx